import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Image, ToolBar } from "../../../utils/general";

import { Mark } from "./assets";

export const WhiteBoard = () => {
  const wnapp = useSelector((state) => state.apps.board);
  const [color, setColor] = useState("#222222");
  const [radii, setRadii] = useState(4);
  const [eraze, setErz] = useState(false);
  const [reset, setRst] = useState(false);
  const [tools, setTools] = useState([
    "#222222",
    "#e92a2a",
    "#2a52e9",
    "#12c629",
    "#e9a21e",
    "#911ee9",
    "erazer",
    "reset",
  ]);

  const action = (e) => {
    var act = e.target.getAttribute("value");
    if (act == "erz") {
      setErz(true);
    } else if (act == "rst") {
      setErz(false);
      setColor("#222");
      setRst(true);
      setTimeout(() => {
        setRst(false);
      }, 50);
    } else {
      setErz(false);
      setColor(act);
    }
  };

  return (
    <div
      className="whiteBoard floatTab dpShad"
      data-size={wnapp.size}
      data-max={wnapp.max}
      style={{
        ...(wnapp.size == "cstm" ? wnapp.dim : null),
        zIndex: wnapp.z,
      }}
      data-hide={wnapp.hide}
      id={wnapp.icon + "App"}
    >
      <ToolBar
        app={wnapp.action}
        icon={wnapp.icon}
        size={wnapp.size}
        name="Whiteboard"
        bg="#f9f9f9"
        noinvert
      />
      <div className="windowScreen flex flex-col" data-dock="true">
        <div className="restWindow flex-grow flex flex-col">
          <div className="clickCont">
            <div className="paintTool">
              {tools.map((tool, ind) => {
                if (tool == "erazer") {
                  return (
                    <div
                      className="ptool prtclk"
                      key={ind}
                      onClick={action}
                      value="erz"
                      data-active={eraze}
                    >
                      <Image src="icon/ui/marker" />
                    </div>
                  );
                } else if (tool == "reset") {
                  return (
                    <div
                      className="ptool prtclk"
                      key={ind}
                      onClick={action}
                      value="rst"
                    >
                      <Image src="icon/ui/dustbin" />
                    </div>
                  );
                } else {
                  return (
                    <div
                      className="ptool prtclk"
                      key={ind}
                      onClick={action}
                      data-active={color == tool && !eraze}
                      value={tool}
                    >
                      <Mark color={tool} />
                    </div>
                  );
                }
              })}
            </div>
          </div>
          <div className="canvaCont">
            {!wnapp.hide && !reset ? (
              <DrawingCanvas
                brushColor={eraze ? "#fff" : color}
                brushRadius={eraze ? 48 : radii}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const DrawingCanvas = ({ brushColor, brushRadius }) => {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    const width = parent?.clientWidth || 800;
    const height = parent?.clientHeight || 500;
    if (canvas.width !== width || canvas.height !== height) {
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
    }
  }, []);

  const point = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  };

  const draw = (event) => {
    if (!drawingRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    if (!ctx) return;
    const { x, y } = point(event);
    ctx.lineTo(x, y);
    ctx.strokeStyle = brushColor;
    ctx.lineWidth = brushRadius;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.stroke();
  };

  const start = (event) => {
    const canvas = canvasRef.current;
    const ctx = canvas?.getContext("2d");
    if (!ctx) return;
    const { x, y } = point(event);
    drawingRef.current = true;
    ctx.beginPath();
    ctx.moveTo(x, y);
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  const stop = (event) => {
    drawingRef.current = false;
    event.currentTarget.releasePointerCapture?.(event.pointerId);
  };

  return (
    <canvas
      ref={canvasRef}
      className="fd-whiteboard-canvas"
      onPointerDown={start}
      onPointerMove={draw}
      onPointerUp={stop}
      onPointerCancel={stop}
    />
  );
};
